import { Dispatch, ThunkAction } from 'app/types/actions';
import { IGetState } from 'app/types/types';
import {
    SegmentCardEvent, SegmentCardOptions,
    SegmentCardSection,
    segmentTrackAction,
    SegmentUserEvent
} from '../../../../../../../../middlewares/segment';
import { showGoogleCalendarsList } from '../effects/showGoogleCalendarsList';
import { authManagerInstance } from 'app/helper/authorisation/google/AuthManager';

export const onOpen = (): ThunkAction => {
    const action = (
        dispatch: Dispatch,
        getState: IGetState
    ) => {
        const option = {
            name: SegmentCardOptions.TYPE,
            value: SegmentCardSection.CUSTOM,
        };
        dispatch(segmentTrackAction(SegmentCardEvent.PUSH_TO_GOOGLE_CALENDAR_BUTTON_CLICKED, option));
        const onShow = () => { dispatch(segmentTrackAction(SegmentUserEvent.PERMISSION_CALENDAR_SCOPE_SHOWN, option)) }
        const onRequest = () => { dispatch(segmentTrackAction(SegmentUserEvent.PERMISSION_CALENDAR_SCOPE_REQUESTED, option)) }
        const onCancel = () => { dispatch(segmentTrackAction(SegmentUserEvent.PERMISSION_CALENDAR_SCOPE_CANCELED, option)) }
        const onApprove = () => { dispatch(segmentTrackAction(SegmentUserEvent.PERMISSION_CALENDAR_SCOPE_GRANTED, option)) }
        authManagerInstance.checkAndRequestCalendar(() => {
            dispatch(showGoogleCalendarsList());
        }, onShow, onCancel, onRequest, onApprove);
    };
    return action;
};
